export const modelName = 'home';
export const FETCH_GAMES_SUCCESS = '@home/FETCH_GAMES_SUCCESS';
export const FETCH_CHEATS_SUCCESS = '@home/FETCH_CHEATS_SUCCESS';
export const FETCH_UPDATED_SUCCESS = '@home/FETCH_UPDATED_SUCCESS';
export const FETCH_FAILED = '@home/FETCH_FAILED';
